import { encodeGetParams, getHeaders } from '../common/util';
import { PATCH } from '../common/consts';
import { API_URL } from '../circulusConfig';

const saveProfileAPI = async (body) => {
  const res = await fetch(`${API_URL}user/profile`, getHeaders(PATCH, body));
  return res.ok ? res.json() : Promise.reject(res);
};

const loadProfileAPI = async (userPId) => {
  const res = await fetch(
    `${API_URL}user/profile?${encodeGetParams({ userPId })}`,
  );
  return res.ok ? res.json() : Promise.reject(res);
};

export { saveProfileAPI, loadProfileAPI };
